<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1A7f45M/tc-custom/9781429933148.jpg?1724089667420" alt="This image is the cover for the book Don't Say a Word"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Don't Say a Word
      </h1>
      <p class="bookDescription body article font2">
        <b>In this taut thriller, two twisted criminals upend the life of a New York City psychiatrist when they kidnap his five-year-old daughter.</b><br/><br/>They’re watching.<br/><br/>They’ve wiretapped the apartment.<br/><br/>They’ve got their daughter.<br/><br/>They told them they’d hurt her if they spoke about it.<br/><br/>They told them, “Don’t say a word . . . ”<br/><br/>Or else . . . <br/><br/><b>Now a major motion picture starring Michael Douglas, Brittany Murphy, and Sean Bean!</b><br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew Klavan
      </h2>
      
      <p class="authorDescription body article">Andrew Klavan (b. 1954) is a highly successful author of thrillers and hard-boiled mysteries. Born in New York City, Klavan was raised on Long Island and attended college at the University of California at Berkeley. He published his first novel, <I>Face of the Earth</I>, in 1977, and continued writing mysteries throughout the eighties, finding critical recognition when <I>The Rain</I> (1988) won an Edgar Award for best new paperback.<BR /> &#160;<BR /> Besides his crime fiction, Klavan has distinguished himself as an author of supernatural thrillers, most notably <I>Don&rsquo;t Say a Word</I> (1991), which was made into a film starring Michael Douglas. He has two ongoing series: Weiss and Bishop, a private-eye duo who made their debut in <I>Dynamite Road </I>(2003), and The Homelanders, a young-adult series about teenagers who fight radical Islam. Besides his fiction, Klavan writes regular opinion pieces for the<I> New York Times, </I>the<I> Wall Street Journal,</I> and other national publications. He lives in Southern California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?26d97606